import { useRef, useEffect } from 'react';

import { debounce } from '../01-core/Utilities';

export interface InfinityMarqueeProps {
  /** The terms */
  terms: string[];
  /** Additional class */
  className?: string;
}

/** Block rendering an infinity marquee */
export const InfinityMarquee = ({ terms, className }: InfinityMarqueeProps) => {
  const ref: React.MutableRefObject<HTMLDivElement | null> = useRef(null);
  const tape: React.MutableRefObject<HTMLDivElement | null> = useRef(null);

  const recalculateDuration = () => {
    if (!ref.current || !tape.current) {
      return;
    }
    const content = tape.current.getBoundingClientRect().width;

    tape.current.style.setProperty('--duration', content / 120 + 's');
  };

  const handleResize = debounce(
    () => {
      recalculateDuration();
    },
    100,
    false,
  );

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    window.requestAnimationFrame(() => {
      recalculateDuration();
    });

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  });

  return (
    <div ref={ref} className={['infinity-marquee', className].join(' ')}>
      <div ref={tape} className="infinity-marquee__tape">
        <span aria-hidden="true">
          {terms.map((term, i) => (
            <span key={i}>{term}</span>
          ))}
        </span>
        <span>
          {terms.map((term, i) => (
            <span key={i}>{term}</span>
          ))}
        </span>
        <span aria-hidden="true">
          {terms.map((term, i) => (
            <span key={i}>{term}</span>
          ))}
          {terms.map((term, i) => (
            <span key={i + terms.length}>{term}</span>
          ))}
        </span>
      </div>
    </div>
  );
};
